import { User } from 'modules/domains/user';
import { useGraphql } from 'utils/hooks/useGraphql';
import { ListReferenceQueryResponse } from './types';
import { fetchListsCreators } from './query';

export const useEmailListsCreatorsQuery = (): {
  listsCreators?: Record<string, User>;
  isLoading: boolean;
  isError: boolean;
} => {
  const {
    data: { emailListsCreators = [] } = {},
    isLoading,
    error: isError,
  } = useGraphql<ListReferenceQueryResponse>(fetchListsCreators);

  const listsCreators =
    emailListsCreators.length > 0
      ? emailListsCreators.reduce((acc, curr) => ({ ...acc, [curr.id]: curr }), {})
      : undefined;

  return {
    listsCreators,
    isLoading,
    isError,
  };
};
